import type { TestContext } from "yup";
import type { ClientDocument } from "../types";

export function assertDocumentRequired(this: TestContext, files: Array<ClientDocument> = []) {
    if (!files.length || files.some(file => !file.documentFileKey)) {
        throw this.createError({
            message: 'At least one document is required'
        });
    }

    return true;
};
